import React from 'react';
import * as go from 'gojs';
import { withRouter } from 'react-router';
import { withLocalize } from "react-localize-redux";
import { connect } from 'react-redux';
import { ReactDiagram } from 'gojs-react';
import { popupActions } from '../../store/popupStore';
import { bindActionCreators } from 'redux';
import { chartActions } from '../../store/charts/chartsStore';
import { searchActions } from '../../store/searchStore';
import { parseQuery } from "../../store/apiWrapper";

class ChartDiagram extends React.Component {
    constructor(props) {
        super(props);
        go.Diagram.licenseKey = "298647e0b3674cc702d90676423d6bf919a175639c8418a30d0310f6e90d3d06329fee2c56d3df9380af4efe1e7dc3d08ac26b209e49503db731d0df45e0d2aab63377a0040e12dea203749398e83aa2fd7b74edc6aa77a0";
    }

    render() {
        var idsParam = this.props.match.params.id;
        var query = "";
        if (idsParam.indexOf('?') !== -1) {
            query = idsParam.substring(idsParam.indexOf('?'), idsParam.length);
            idsParam = idsParam.substring(0, idsParam.indexOf('?'));
        }
        else
            query = this.props.location.search;

        var params = query ? parseQuery(query) : null;
        const ids = idsParam.split(',').map(x => parseInt(x));

        return (
            <>
                <div id="diagramPlane" style={{ width: '100%', height: '100%' }}>
                    {this.props.domainsInitialized && <ReactDiagram
                        initDiagram={() => this.props.initializeDiagram(
                            ids,
                            params,
                            (type, data) => this.showCustomEntityPopup(type, data),
                            (message, node, idOnly) => this.showRelationUnlimitedPopup(message, node, idOnly),
                            (type, data) => this.showCustomRelationPopup(type, data),
                            () => this.showCustomSearchPopup(),
                            (info) => this.addToClipboard(info),
                            (info) => this.removeFromClipboard(info),
                            (message) => this.showInformationMessagePopup(message),
                            (message, onConfirm) => this.showWarningMessagePopup(message, onConfirm),
                        )}
                        divClassName='myDiagramDiv'
                    />}
                    <div id="exportContext" className="test"></div>
                </div>
            </>
        );
    }

    componentDidUpdate(prevProps) {
        if (this.props.domainsInitialized && !this.props.loading &&
            prevProps.location && this.props.location && this.props.location.search
        ) {
            const prevVisId = (parseQuery(prevProps.location.search || "") || {}).visualizationId;
            const visId = (parseQuery(this.props.location.search) || {}).visualizationId;

            if (prevVisId !== visId) {
                this.props.loadVisualization(visId);
            }
        }
    }

    showCustomEntityPopup(type, data) {
        this.props.showPopup('customEntityPopup', {
            open: true,
            close: () => this.props.hidePopup(),
            entityPopupType: type,
            data,
            editCustomEntity: (_data) => this.props.editCustomEntity(_data),
            newCustomRelation: (_data) => this.props.newCustomRelation(_data)
        });
    }

    showCustomRelationPopup(type, data) {
        this.props.showPopup('customRelationPopup', {
            open: true,
            close: () => this.props.hidePopup(),
            relationPopupType: type,
            data,
            editCustomRelation: (_data, customLinkLabel) => this.props.editCustomRelation(_data, customLinkLabel),
            addCustomRelation: (_data, customLinkLabel) => this.props.addCustomRelation(_data, customLinkLabel),
            deleteCustomRelation: (relationId) => this.props.deleteCustomRelation(relationId)
        })
    }

    showCustomSearchPopup() {
        this.props.showPopup('customSearchPopup', {
            open: true,
            close: () => this.props.hidePopup(),
            newCustomEntity: () => this.props.newCustomEntity(),
            newCustomRelation: (_data) => this.props.newCustomRelation(_data)
        })
    }

    showInformationMessagePopup(message) {
        this.props.showPopup('informationMessagePopup', {
            open: true,
            close: () => this.props.hidePopup(),
            message
        })
    }

    showRelationUnlimitedPopup(message, node, idOnly) {
        this.props.showPopup('relationsUnlimitedPopup', {
            open: true,
            close: () => this.props.hidePopup(),
            showNextLevel: () => this.props.showNextLevel(node, idOnly),
            message
        })
    }

    showWarningMessagePopup(message, onConfirm) {
        this.props.showPopup('warningMessagePopup', {
            open: true,
            close: () => this.props.hidePopup(),
            onConfirm: () => {
                onConfirm();
                this.props.hidePopup();
            },
            message: message
        })
    }

    addToClipboard(info) {
        this.props.addToClipboard(info, this.props.translate('Search.Clipboard.SubjectAdded'));
    }

    removeFromClipboard(info) {
        this.props.removeFromClipboard(info, this.props.translate('Search.Clipboard.SubjectRemoved'));
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.charts, layout: state.layout }),
    dispatch => bindActionCreators(({ ...chartActions, ...popupActions, ...searchActions }), dispatch)
)(ChartDiagram)));